import { useDrag } from 'react-dnd';

import { List, ListItem, Typography } from '@mui/material';
import { Service } from '../../../../../models/masters/service';
interface ServiceListGroup {
  serviceGroupID: number;
  serviceGroupName: string;

  services: Service[];
}
interface ServiceListDraggableProps {
  services: ServiceListGroup[];
}

const ServiceItem = ({ service }: { service: Service }) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'service',
    item: { type: 'service', service },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'move',
        display: 'flex', // Set layout to flex
        justifyContent: 'space-between', // Spread items evenly
        alignItems: 'center', // Align items vertically in the center
      }}
    >
      {/* {service.serviceName} */}
      <Typography variant="body1">{service.serviceName}</Typography>
      <Typography variant="body2" color="textSecondary">
        {service.procedure}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {service.price !== 0 && service.price && `$${service?.price}`}
      </Typography>
    </div>
  );
};

const ServiceGroupItem = ({ serviceGroup }: { serviceGroup: ServiceListGroup }) => {
  const [{ isDragging }, dragList] = useDrag({
    type: 'serviceGroup',
    item: { type: 'serviceGroup', serviceGroup },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  return (
    <div
      // draggable="true"
      ref={dragList}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'move',
        // display: 'flex', // Set layout to flex
        // justifyContent: 'space-between', // Spread items evenly
        // alignItems: 'center', // Align items vertically in the center
      }}
    >
      {/* Bold the service group name */}

      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {serviceGroup?.serviceGroupName}
      </Typography>

      <List>
        {/* List services with procedure and invoice amount */}
        {serviceGroup?.services?.map((service) => (
          <ListItem key={service.serviceID}>
            <ServiceItem service={service} />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export const ServiceListDraggable = ({ services }: ServiceListDraggableProps) => {
  const sortedServicesGroup = services.sort((a: ServiceListGroup, b: ServiceListGroup) =>
    a.serviceGroupName < b.serviceGroupName ? -1 : 1
  );

  return (
    <div className="slplitBlock bundlePopupMaxHeight">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <strong style={{ width: '50%' }}>Services</strong>
        <strong style={{ width: '50%' }}>Predecessor</strong>
        <strong style={{ width: '20%' }}>Invoice amount</strong>
      </div>
      <div>
        <List>
          {sortedServicesGroup?.map(
            (serviceGroup) =>
              serviceGroup?.services?.length > 0 && (
                <ListItem key={serviceGroup.serviceGroupID}>
                  <ServiceGroupItem serviceGroup={serviceGroup} />
                </ListItem>
              )
          )}
        </List>
      </div>
    </div>
  );
};
